import { createFormHook } from '@tanstack/react-form';
import { DropdownField } from '~/components/Forms/FieldComponents/DropdownField';
import {
    LevelField,
    LevelsField,
} from '~/components/Forms/FieldComponents/LevelField';
import { URLField } from '~/components/Forms/FieldComponents/URLField';
import { fieldContext, formContext } from './useFormContext';
import { SubscribeButton } from '~/components/Forms/FormComponents/SubscribeButton';
import { CompletionTimeField } from '~/components/Forms/FieldComponents/CompletionTime';
import {
    SearchField,
    TextField,
} from '~/components/Forms/FieldComponents/TextField';
import { TextAreaField } from '~/components/Forms/FieldComponents/TextAreaField';
import { CountryField } from '~/components/Forms/FieldComponents/CountryField';
import { SwitchField } from '~/components/Forms/FieldComponents/SwitchField';
import { LevelThumbnailField } from '~/components/Forms/FieldComponents/LevelThumbnailField';
import { NumberField } from '~/components/Forms/FieldComponents/NumberField';
import { SegmentedRadioField } from '~/components/Forms/FieldComponents/SegmentedRadioField';
import { DropdownBooleanField } from '~/components/Forms/FieldComponents/DropdownBooleanField';
import {
    UserField,
    UsersField,
} from '~/components/Forms/FieldComponents/UserField';
import { SubmissionStatusField } from '~/components/Forms/FieldComponents/SubmissionStatusField';
import { CheckboxField } from '~/components/Forms/FieldComponents/CheckboxField';
import { LevelTagsField } from '~/components/Forms/FieldComponents/LevelTagsField';
import { ColorField } from '~/components/Forms/FieldComponents/ColorField';
import { BanLevelField } from '~/components/Forms/FieldComponents/BanLevelField';
import {
    RoleField,
    RolesField,
} from '~/components/Forms/FieldComponents/RolesField';
import {
    DateField,
    DateTimeField,
} from '~/components/Forms/FieldComponents/DateTimeField';
import { PermissionsField } from '~/components/Forms/FieldComponents/PermissionsField';
import { TimezoneField } from '~/components/Forms/FieldComponents/TimezoneField';

export const { useAppForm } = createFormHook({
    fieldContext,
    formContext,
    fieldComponents: {
        URLField,
        CheckboxField,
        LevelField,
        LevelsField,
        DropdownField,
        DropdownBooleanField,
        CompletionTimeField,
        TextField,
        SearchField,
        NumberField,
        TextAreaField,
        CountryField,
        SegmentedRadioField,
        SwitchField,
        LevelThumbnailField,
        UserField,
        UsersField,
        SubmissionStatusField,
        LevelTagsField,
        ColorField,
        BanLevelField,
        RolesField,
        RoleField,
        DateTimeField,
        DateField,
        PermissionsField,
        TimezoneField,
    },
    formComponents: { SubscribeButton },
});
